<template>
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox" :id="id"
      @change="$emit('input', value)"
      :checked="checked"
    >
    <label class="form-check-label" :for="id" v-text="label"></label>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: ['label', 'checked', 'value'],
    data() {
      return {
        id: window._.uniqueId('step_')
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/CustomCheckbox.vue